export const PRIVILEGE_KEYS = {
  ALL: 0,
  READ_ONLY: 1,
} as const;

export type PrivilegeValue = typeof PRIVILEGE_KEYS[keyof typeof PRIVILEGE_KEYS]; // 0 | 1

export const Privileges: Record<PrivilegeValue, 'ALL' | 'READ_ONLY'> = {
  [PRIVILEGE_KEYS.ALL]: 'ALL',
  [PRIVILEGE_KEYS.READ_ONLY]: 'READ_ONLY',
};

export const defaultUserPrivilege: PrivilegeValue = PRIVILEGE_KEYS.ALL;